import React, { FunctionComponent } from "react";
import { Text } from "../../text/text";

export interface FormFieldTextLengthIndicatorProps {
  id: string;
  textLength: { current: number; max: number };
  className: string;
}

/**
 * This component is intended to be used internally by the FormField component.
 */
export const FormFieldTextLengthIndicator: FunctionComponent<FormFieldTextLengthIndicatorProps> = ({
  id,
  textLength,
  className,
}) => (
  <Text id={id} variant="helper-text" className={className}>
    <span className="sr-only">Text length: </span>
    {textLength.current}/{textLength.max}
  </Text>
);
